// Screenname:PaymentTerms master
// Developer Name: Jagadish.
// Created date on: 2 / 2 / 2023
// Comments and Suggestions:
// TS File: Service
// Messages: 
import httpbaseURL from '../common/axios';
class PaymentTermsservices {
    createdata(doc) {
        return httpbaseURL.httpMSInventoryUrl.post("/PaymentTermsMAS/Create", doc)
    }
    getdata() {
        return httpbaseURL.httpMSInventoryUrl.get("/PaymentTermsMAS/List")
    }
    getfindonedata(doc) {
        return httpbaseURL.httpMSInventoryUrl.get("/PaymentTermsMAS/Get?id=" + doc)
    }
    updatedata(doc) {
        return httpbaseURL.httpMSInventoryUrl.post("/PaymentTermsMAS/Update", doc)
    }
    deletedata(doc) {
        return httpbaseURL.httpMSInventoryUrl.delete("/PaymentTermsMAS/Delete?id=" + doc)
    }
    active(DelID, Status) {
        debugger;
        return httpbaseURL.httpMSInventoryUrl.put(
            "PaymentTermsMAS/Active?id=" + DelID + "&Status=" + Status + ""
        );
    }
}
export default new PaymentTermsservices()